import { useId } from 'react'
import type { JSX } from 'react'

import { Button, Dialog, Flex, Input, Text } from '@buffer-mono/popcorn'

import { ApiKeySafetyNotice } from '~publish/pages/Settings/shared/components/ApiKeySafetyNotice/ApiKeySafetyNotice'
import { CopyButton } from '~publish/pages/Settings/shared/components/CopyButton'

import styles from './TokenSuccessDialog.module.css'

// One bullet per character (except the last four) so the field stays at
// full length but the value is never visible.
function maskTokenFullLength(token: string): string {
  if (token.length <= 4) return token
  return '•'.repeat(token.length - 4) + token.slice(-4)
}

interface TokenSuccessDialogProps {
  open: boolean
  onClose: () => void
  token: string
  title?: string
  label?: string
}

export const TokenSuccessDialog = ({
  open,
  onClose,
  token,
  title = 'API Key Generated',
  label = 'Your API Key',
}: TokenSuccessDialogProps): JSX.Element => {
  const keyId = useId()

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <Dialog.Content size="medium">
        <Dialog.Header>
          <Dialog.Title>{title}</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body className={styles.body}>
          <div className={styles.tokenSection}>
            <Text
              as="label"
              htmlFor={keyId}
              weight="medium"
              className={styles.label}
            >
              {label}
            </Text>
            <Flex gap="xs" align="center">
              <Input
                id={keyId}
                value={maskTokenFullLength(token)}
                readOnly
                className={styles.maskedToken}
              />
              <CopyButton textToCopy={token} label="Copy key" />
            </Flex>
          </div>
          <ApiKeySafetyNotice dismissible={false} />
        </Dialog.Body>
        <Dialog.Footer>
          <Button variant="primary" onClick={onClose}>
            Done
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
